import { FormService } from './FormService';

export class SupplierNcrService extends FormService {
    constructor() {
        super("SupplierNcrs");
    }
}